import { Box, Typography } from "@mui/material";
import { DocumentSectionProps } from "../types";
import { DocumentTable } from "../document-table";

const getLetterFromIndex = (index?: number) => {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  if (index === undefined) return "?";
  return letters[index];
};

const convertToRoman = (num: number): string => {
  if (num < 1) {
    return "";
  }
  if (num >= 40) {
    return "XL" + convertToRoman(num - 40);
  }
  if (num >= 10) {
    return "X" + convertToRoman(num - 10);
  }
  if (num >= 9) {
    return "IX" + convertToRoman(num - 9);
  }
  if (num >= 5) {
    return "V" + convertToRoman(num - 5);
  }
  if (num >= 4) {
    return "IV" + convertToRoman(num - 4);
  }
  if (num >= 1) {
    return "I" + convertToRoman(num - 1);
  }
  return "";
};

export const DocumentSection = ({
  id,
  title,
  subTitle,
  description,
  index,
  sx,
  layer = 0,
  table,
}: DocumentSectionProps) => {
  const currentIndex = typeof index === "number" && index !== 0 ? index : index;
  const isChild = layer > 0;
  const letterIndex = isChild ? getLetterFromIndex(index) : null;

  const isFirstTitleInDocument = currentIndex === 0 && !isChild;

  const romanIndex = convertToRoman((currentIndex ?? 0) + 1);

  const sectionIndex =
    layer === 0 ? currentIndex : layer === 1 ? letterIndex : romanIndex;

  return (
    <Box
      className="document-section"
      id={id}
      sx={{
        pl: isChild ? 4 : 0,
        ...sx,
      }}
    >
      {title && (
        <Typography variant={isChild ? "h6" : "h5"}>
          {!isFirstTitleInDocument ? `${sectionIndex}. ` : ""}
          {title}
        </Typography>
      )}

      {subTitle && typeof subTitle === "string" && (
        <Typography variant="body1">{subTitle}</Typography>
      )}
      {subTitle &&
        typeof subTitle !== "string" &&
        subTitle.map((content) => (
          <Typography key={content} variant="body1" mt={1.5}>
            {content}
          </Typography>
        ))}

      {description &&
        description.map((content, childIndex) => {
          if (typeof content === "string" && layer === 2) {
            return (
              <li
                style={{
                  marginTop: "1.5rem",
                  listStyleType: "lower-roman",
                }}
                key={childIndex}
              >
                <Typography variant="body1" component="span">
                  {content}
                </Typography>
              </li>
            );
          }

          if (typeof content === "string") {
            return (
              <Typography key={childIndex} variant="body1">
                {content}
              </Typography>
            );
          }
          return (
            <DocumentSection
              key={childIndex}
              {...content}
              layer={layer + 1}
              index={childIndex}
              id={`${id}-${childIndex}`.replace("#", "")}
              sx={{
                mt: 2,
              }}
            />
          );
        })}

      {table && <DocumentTable headers={table.headers} values={table.values} />}
    </Box>
  );
};
